var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpiresSoon = function SvgExpiresSoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2358F8",
    d: "M9.375 1.625a.617.617 0 0 0 .625-.61V.61C10 .273 9.72 0 9.375 0H.625A.617.617 0 0 0 0 .61v.406c0 .336.28.609.625.609 0 2.31 1.329 4.259 3.147 4.875C1.954 7.116.625 9.065.625 11.375a.617.617 0 0 0-.625.61v.406c0 .336.28.609.625.609h8.75a.617.617 0 0 0 .625-.61v-.406c0-.336-.28-.609-.625-.609 0-2.31-1.329-4.259-3.147-4.875 1.818-.616 3.147-2.565 3.147-4.875M5 5.281c-1.505 0-2.708-1.689-2.708-3.656h5.416c0 1.98-1.21 3.656-2.708 3.656"
  })));
};
export default SvgExpiresSoon;